import React, { useState } from 'react'
import { DataActividadSave, DetalleGrupoActividadHEDTO, RegimenLaboralHEDTO, ServidorSeleccionado } from '../PlanificacionHE/TypesPlanificacionHE';
import { DetalleActividadProyHEDTO, DetalleServidoresProyHEDTO } from './TypesProyeccionDirectivo';
import { DetalleParametrosProyeccionHE } from 'components/Admin/Horas Extras/Parametros Horas Extras/TypesParametrosHorasExtras';
import TableDetalleActividadHE from '../PlanificacionHE/TableDetalleActividadHE';


import { Row, Col, Button, Table } from "reactstrap";

import { ReactComponent as AgregarSVG } from "assets/icons/HorasExtras/Agregar ACt.svg";
import { ReactComponent as EditarSVG } from "assets/icons/HorasExtras/editar.svg";
import ModalAsignarServidoresPlanHE from 'components/Varios/Modals/ModalAsignarServidoresPlanHE';
import ModalConfirmacionNew from 'components/Varios/Modals/ModalConfirmacionNew';


import SaveSVG from "./../../../../assets/icons/HorasExtras/Guardar.svg"
import DeleteSVG from "./../../../../assets/icons/HorasExtras/Msg ELIMINAR.svg"
import { EditarProyeccionbyActividad, EliminarProyeccionbyActividad, GuardarProyeccionbyActividad } from './FunctionsProyeccionDirectivoUnidad';
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';


import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg"


type ModalConfirmacionActividad = {
    showModal: boolean,
    solicitud: DataActividadSave,
    content: HTMLElement | undefined
}

type PropsActividadProyeccionHE = {
    regimenLaborales: RegimenLaboralHEDTO[];
    listadoServidores: DetalleServidoresProyHEDTO[] | undefined;
    recargarInformacion: () => Promise<void>
    actividadSeleccionadaEditar?: DetalleActividadProyHEDTO;
    paramsProyeccionHE: DetalleParametrosProyeccionHE;
    detalleActividadPlanHEDTOs: DetalleActividadProyHEDTO[] | undefined;
    idProyeccionUnidad: number;
    idSolicitudReverso: number;
    estadoProyeccion: string;
    mensajeNovedad: string;
    gruposActividad: DetalleGrupoActividadHEDTO[],
    idEstructura: number,


    puedeRealizarAccion?: boolean
    guardarParcial: () => void
    enviarTh: () => void
    solicitarReverso: () => void
    

    mostrarGuardarParcial?: boolean | undefined;
    mostrarFirmaryEnviar?: boolean | undefined;
    mostrarSolicitarReverso?: boolean | undefined;
    mostrarReporteResumenProyPlanifExcel?: boolean
    loadingAccionReporteExcel?: boolean
    descargarResumenExcel?: () => Promise<void>
}


export default function ActividadProyeccionHE(props: PropsActividadProyeccionHE) {

    const [regimenLaboralSeleccionado, setRegimenLaboralSeleccionado] = useState(props.actividadSeleccionadaEditar?.idregimenLaboral || 0);

    const [updatedDetalleActividades, setUpdatedDetalleActividades] = useState<DetalleActividadProyHEDTO[]>(props.detalleActividadPlanHEDTOs ?? []);

    const [horasSuplementarias, setHorasSuplementarias] = useState<number | undefined>(props.actividadSeleccionadaEditar?.horasSuplementarias);
    const [horasExtraordinarias, setHorasExtraordinarias] = useState<number | undefined>(props.actividadSeleccionadaEditar?.horasExtraordinarias);

    const [observacion, setObservacion] = useState(props.actividadSeleccionadaEditar?.observacion || '');


    let actividadesProyectadas: number[] = [];

    if (props.detalleActividadPlanHEDTOs) {
        actividadesProyectadas = props.detalleActividadPlanHEDTOs.map((v) => { return (v.idactividad) })
    }


    const realizarAcciones: boolean = (props.puedeRealizarAccion !== undefined && props.puedeRealizarAccion === true) || (props.puedeRealizarAccion === undefined)


    //Modal COnfirmacion
    const defaultDataActividadSave: DataActividadSave = {
        regimenLaboralSeleccionado: 0,
        actividadSeleccionada: 0,
        horasSuplementarias: 0,
        horasExtraordinarias: 0,
        observacion: '',
        servidoresSeleccionados: []
    };

    const defaultStateModalConfirmacionAct = {
        showModal: false,
        solicitud: defaultDataActividadSave,
        content: undefined
    }

    const [modalConfirmacionActividad, setModalConfirmacionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);
    const [modalEdicionActividad, setModalEdicionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);
    const [modalEliminacionActividad, setModalEliminacionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);

    //Tabla
    const [data, setData] = useState<DataActividadSave | undefined>(undefined)
    const [isCrear, setIsCrear] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);


    const [actividadSeleccionada, setActividadSeleccionada] = useState(props.actividadSeleccionadaEditar?.idactividad || 0);

    const [selectedServidores, setSelectedServidores] = useState<{ [key: number]: ServidorSeleccionado }>(
        props.actividadSeleccionadaEditar?.servidoresPlanificados.reduce((acc, servidor) => {
            acc[servidor.key] = servidor.value;
            return acc;
        }, {} as { [key: number]: ServidorSeleccionado }) || {}
    );

    //Fin Tabla

    const handleEdit = (detalleActividad: DataActividadSave) => {
        setData(detalleActividad);
        setIsCrear(false);
        setModalOpen(true);
    };



    function GetHTMLActividadesPlanificadas(solicitud: DataActividadSave, nombreActividad: string): React.ReactNode {
        const sortedServidores = solicitud.servidoresSeleccionados.sort((a, b) => {
            const nombreA = a.value.nombrecompleto.toLowerCase();
            const nombreB = b.value.nombrecompleto.toLowerCase();
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        const htmlRowsSolicitudes = (
            <>
                <div className="modal-body">
                    <p><strong>Nombre actividad:</strong> {nombreActividad}</p>
                    {/* <p><strong>Descripción específica de la actividad:</strong> {solicitud.observacion}</p> */}
                    <Table responsive bordered className="table_planificacion_he">
                        <thead className="cabeceras_tabla_planificacion_he">
                            <tr>
                                <th>#</th>
                                <th>Cédula</th>
                                <th>Nombres</th>
                                <th>Cargo</th>
                                <th>Régimen</th>
                                <th>H. Suplementarias</th>
                                <th>H. Extraordinarias</th>
                                <th>Total Horas</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedServidores.map((servidor,i) => {
                                var totalHoras: undefined | number = undefined;
                                if (servidor.value.horasSuplementarias !== undefined || servidor.value.horasExtraordinarias !== undefined) {
                                    totalHoras = (servidor.value.horasSuplementarias ?? 0) + (servidor.value.horasExtraordinarias ?? 0)
                                }


                                return (

                                    <tr className='rows_tabla_planificacion_he' key={servidor.key}>
                                        <td className="centrado">{i+1}</td>
                                        <td>{servidor.value.identificacion}</td>
                                        <td>{servidor.value.nombrecompleto}</td>
                                        <td>{servidor.value.cargo}</td>
                                        <td className='centrado'>{servidor.value.siglasregimen}</td>
                                        <td className='centrado'>{servidor.value.horasSuplementarias}</td>
                                        <td className='centrado'>{servidor.value.horasExtraordinarias}</td>
                                        <td className='centrado'>{totalHoras}</td>
                                    </tr>

                                )
                            }

                            )}

                        </tbody>
                    </Table>
                </div>
            </>
        );

        return htmlRowsSolicitudes;
    }



    const handleDelete = async (data: DataActividadSave, nombreActividad: string) => {
        const content: any = GetHTMLActividadesPlanificadas(data, nombreActividad)
        setModalEliminacionActividad(
            {
                showModal: true,
                solicitud: data,
                content
            })
    }

    const toggleModal = () => {
        setIsCrear(true)
        setModalOpen(!modalOpen);
    };

    const handleSubmit = (dataActividadSave: DataActividadSave, nombreActividad: string) => {
        const content: any = GetHTMLActividadesPlanificadas(dataActividadSave, nombreActividad)

        if (isCrear) {
            setModalConfirmacionActividad(
                {
                    showModal: true,
                    solicitud: dataActividadSave,
                    content
                })
        } else {
            setModalEdicionActividad(
                {
                    showModal: true,
                    solicitud: dataActividadSave,
                    content
                })
        }

    };


    async function handleGuardarProyeccion(solicitud: DataActividadSave) {
        const result = await GuardarProyeccionbyActividad(solicitud);
        if (result.status === 200 && result.dataResponse) {
            showAlert("La proyección de la actividad se ha guardado correctamente.", true);
            setUpdatedDetalleActividades(result.dataResponse);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await props.recargarInformacion()
            return 1;
        } else {
            const mensajeDefault = "Ha ocurrido un inconveniente."
            showAlert(result.errorMessage ?? mensajeDefault, false);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await props.recargarInformacion()
            return -1;
        }

    }


    const resetFormValues = () => {
        setRegimenLaboralSeleccionado(0);
        setActividadSeleccionada(0);
        setHorasSuplementarias(undefined);
        setHorasExtraordinarias(undefined);
        setObservacion('');
        setSelectedServidores({});
        setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
    };


    async function handleDeleteActividad(idActividad: number) {
        const result = await EliminarProyeccionbyActividad(idActividad);
        if (result.status === 200 && result.dataResponse) {
            showAlert("La proyección de la actividad se ha eliminado correctamente.", true);
            setUpdatedDetalleActividades(result.dataResponse);
            setModalEliminacionActividad(defaultStateModalConfirmacionAct);
            await props.recargarInformacion()
            return 1;
        } else {
            const mensajeDefault = "Ha ocurrido un inconveniente."
            showAlert(result.errorMessage ?? mensajeDefault, false);
            setModalEliminacionActividad(defaultStateModalConfirmacionAct);
            await props.recargarInformacion()
            return -1;
        }
    }

    async function HandleEditarProyeccion(solicitud: DataActividadSave) {
        const result = await EditarProyeccionbyActividad(solicitud);
        if (result.status === 200 && result.dataResponse) {
            showAlert("La proyección de la actividad se ha editado correctamente.", true);
            setUpdatedDetalleActividades(result.dataResponse);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await props.recargarInformacion()
            return 1;
        } else {
            const mensajeDefault = "Ha ocurrido un inconveniente."
            showAlert(result.errorMessage ?? mensajeDefault, false);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await props.recargarInformacion()
            return -1;
        }

    }

    // const handleGuardarPlanificacion = async (solicitud: DataActividadSave) => {
    //     const result = await GuardarPlanificacionbyActividad(solicitud);
    //     if (result.status === 200) {
    //         showAlert("La planificación de la actividad se ha guardado correctamente.", ExitoSVG, true);
    //         setUpdatedDetalleActividades(result.dataResponse);
    //         setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
    //         await recargarInformacion()
    //         return 1;
    //     } else {
    //         showAlert(result.errorMessage, ErrorSVG, true);
    //         setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
    //         await recargarInformacion()
    //         return -1;
    //     }

    // };


    return (
        <React.Fragment>
            {
                !props.mensajeNovedad && (
                    <>

                        <Row className="justify-content-end row-no-margin">


                            {props.mostrarReporteResumenProyPlanifExcel && typeof (props.descargarResumenExcel) === "function" && (
                                <Col className="d-flex" md="auto">
                                    <Button
                                        disabled={props.loadingAccionReporteExcel}
                                        onClick={props.descargarResumenExcel}
                                        className="btn-Excel "
                                    >
                                        <div className="containerBotonImprimir">
                                            <div>Exportar a Excel</div>
                                            <IconoExcel className="iconBotonImprimir" />
                                        </div>
                                    </Button>
                                </Col>

                            )}

                            {
                                realizarAcciones && (
                                    <React.Fragment>
                                        {
                                            props.idProyeccionUnidad === 0 ? (
                                                <Col className="d-flex" md="auto">
                                                    <Button className="btn-ingresar" title="Ingresar nueva actividad" onClick={toggleModal}>
                                                        <AgregarSVG /> Ingresar nueva actividad
                                                    </Button>
                                                </Col>
                                            )
                                                : (
                                                    <Col className="d-flex " md="auto">
                                                        <Button className="btn-ingresar" title="Modificar proyección" onClick={toggleModal}>
                                                            <EditarSVG /> Modificar proyección
                                                        </Button>
                                                    </Col>
                                                )
                                        }
                                    </React.Fragment>

                                )
                            }


                            <Col className="d-flex" md="auto">

                                {realizarAcciones && (
                                    <>
                                        {props.mostrarGuardarParcial && (
                                                <Button className="btn-guardar" onClick={props.guardarParcial}>
                                                    Guardar
                                                </Button>
                                        )}
                                        {props.mostrarFirmaryEnviar && (
                                                <Button className="btn-firmar" onClick={props.enviarTh}>
                                                    Enviar a TH
                                                </Button>
                                        )}
                                    </>
                                )}
                                {props.mostrarSolicitarReverso && (
                                    <Button className="btn-solicitar" onClick={props.solicitarReverso}>
                                        Solicitar reverso
                                    </Button>
                                )}





                            </Col>

                        </Row>
                    </>
                )
            }
            {
                updatedDetalleActividades.length === 0 && <div>Aún no se han asignado actividades para la proyección de la unidad</div>
            }
            {
                updatedDetalleActividades && updatedDetalleActividades.length > 0 && (
                    <TableDetalleActividadHE
                        mensajeNovedad={props.mensajeNovedad}
                        detalleActividadPlan={updatedDetalleActividades}
                        estadoPlanificacion={props.estadoProyeccion ?? ""}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        tipo='PR'
                        idEstructura={props.idEstructura}
                        puedeRealizarAccion={realizarAcciones}
                    />
                )
            }

            {
                props.listadoServidores && props.listadoServidores.length > 0 &&
                <ModalAsignarServidoresPlanHE
                    isOpen={modalOpen}
                    toggle={toggleModal}
                    isCrear={isCrear}
                    servidoresPlan={props.listadoServidores}
                    regimenSeleccionado={regimenLaboralSeleccionado}
                    selectedServidoresAnt={selectedServidores}
                    regimenLaborales={props.regimenLaborales}
                    paramsHorasMesPlanificacionHE={props.paramsProyeccionHE.listadoparametroshorasregimen}
                    handleSubmit={handleSubmit}
                    data={data}
                    gruposActividad={props.gruposActividad}
                    regimenLaboralesPlan={[]}
                    actividadesProyectadasPlanificadas={actividadesProyectadas}
                    tipo='PR'
                    idEstructura={props.idEstructura}

                />
            }

            <ModalConfirmacionNew
                show={modalConfirmacionActividad.showModal}
                size="lg"
                onClose={() => {
                    setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
                    resetFormValues();
                }}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea proyectar esta actividad?"}
                nombreBotonAccion={"Aceptar"}
                nombreBotonCerrarModal={"Cancelar"}
                asyncOnClick={async () => await handleGuardarProyeccion(modalConfirmacionActividad.solicitud)}
                contentModal={modalConfirmacionActividad.content}
                tituloModal={"Guardar proyección de actividad"}
                botonesAccionParteSuperior={true}
                iconModal={SaveSVG}
                classNamemensajeConfirmacion={"mensaje-confirmacion"}
            />

            <ModalConfirmacionNew
                show={modalEdicionActividad.showModal}
                size="lg"
                onClose={() => {
                    setModalEdicionActividad(defaultStateModalConfirmacionAct);
                    resetFormValues();
                }}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea editar la proyección de esta actividad?"}
                nombreBotonAccion={"Aceptar"}
                nombreBotonCerrarModal={"Cancelar"}
                asyncOnClick={async () => await HandleEditarProyeccion(modalEdicionActividad.solicitud)}
                contentModal={modalEdicionActividad.content}
                tituloModal={"Editar proyección de actividad"}
                botonesAccionParteSuperior={true}
                iconModal={SaveSVG}
                classNamemensajeConfirmacion={"mensaje-confirmacion"}
            />




            <ModalConfirmacionNew
                show={modalEliminacionActividad.showModal}
                size="lg"
                onClose={() => {
                    setModalEliminacionActividad(defaultStateModalConfirmacionAct);
                    resetFormValues();
                }}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea eliminar la proyección de esta actividad para todos los servidores listados a continuación?"}
                nombreBotonAccion={"Aceptar"}
                nombreBotonCerrarModal={"Cancelar"}
                asyncOnClick={async () => await handleDeleteActividad(modalEliminacionActividad.solicitud.actividadSeleccionada)}
                //asyncOnClick={async () => await  ObtenerDiccionario()}
                contentModal={modalEliminacionActividad.content}
                tituloModal={"Eliminar proyección de actividad"}
                botonesAccionParteSuperior={true}
                iconModal={DeleteSVG}
                classNamemensajeConfirmacion={"mensaje-confirmacion"}
            />



        </React.Fragment>

    )
}

